import {Component, Input} from '@angular/core';
import {NextStoryCard} from "./next-story-card";

@Component({
  selector: 'brt-next-story-card',
  templateUrl: './next-story-card.component.html',
  styleUrls: ['./next-story-card.component.scss']
})
export class NextStoryCardComponent {
  @Input('data') set setData(data: NextStoryCard) {
    this.data = data;
    console.warn(this.data);
  }
  data!: NextStoryCard;

}
